import * as React from 'react'; 
import { IS_MOBILE } from '../../../config';


export interface ImgContainerProps{
    className?:string;
    imgUrl: string;
    alt: string;
    prev:() => void;
    next:() => void;
}

export interface ImgContainerState{

}

export class ImgContainer extends React.Component<ImgContainerProps, ImgContainerState>{
    el:HTMLDivElement;
    xDown = null;
    yDown = null;
    
    constructor(p:ImgContainerProps){
        super(p);
    }

    componentDidMount() {
        if (IS_MOBILE) {
            this.el.addEventListener("touchstart", this.handleTouchStart, false);
            this.el.addEventListener("touchmove", this.handleTouchMove, false);
        }
    }

    componentWillUnmount() {
        if (IS_MOBILE) {
            this.el.removeEventListener("touchstart", this.handleTouchStart, false);
            this.el.removeEventListener("touchmove", this.handleTouchMove, false);
        }
    }

    handleTouchStart = (evt) => {
        this.xDown = evt.touches[0].clientX;
        this.yDown = evt.touches[0].clientY;
    }

    handleTouchMove = (evt) => {
        if (!this.xDown || !this.yDown) {
            return;
        }
    
        let xUp = evt.touches[0].clientX;
        let yUp = evt.touches[0].clientY;
    
        let xDiff = this.xDown - xUp;
        let yDiff = this.yDown - yUp;
    
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                /* left swipe */
                this.props.next();
            } else {
                /* right swipe */
                this.props.prev();
            }
        } 
        /* reset values */
        this.xDown = null;
        this.yDown = null;
    }

    render(){
        let props = this.props, 
            state = this.state,
            cls = this.props.className || "";

        return (
            <div className={"img-container " + cls} ref={e=> this.el= e}
                 style={{ backgroundImage: `url(${props.imgUrl})` }}
            >
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/ImgContainer/ImgContainer.tsx